import { CardItemSkeleton } from '../card-item/card-item.skeleton';

import * as Styled from './cards-module.styles';
import { NUMBER_OF_CARD_SKELETON_ITEMS } from './constants';

export const CardsModuleSkeleton: React.FC = () => {
  return (
    <Styled.CardsModuleContainer
      aria-live="polite"
      aria-busy="true"
      data-testid="recommendation-cards-module-skeleton"
    >
      {Array.from({ length: NUMBER_OF_CARD_SKELETON_ITEMS }).map((_, index) => (
        <Styled.SkeletonCardItem key={index}>
          <CardItemSkeleton />
        </Styled.SkeletonCardItem>
      ))}
    </Styled.CardsModuleContainer>
  );
};
